import { LiveOperator, SaleParameters } from "../../../typings/live";
import { Enums } from "../../../thor.enums";

export class LiveSaleSummaryController {
    public static $inject: string[] = ["dateService", "localeNumber", "sitesService", "utilsService"];

    // binded
    public liveOperators: LiveOperator[];
    public liveSale: SaleParameters;
    public saleCurrency: Enums.Currency;
    public startAt: string;

    public currencySymbol: string;
    public judicialFee: string;
    public voluntaryFee: string;
    public vehiclesFeesWithoutTaxes: string;

    constructor(private dateService, private localeNumber, public sitesService, private utils) {}

    public $onInit() {
        this.currencySymbol = this.localeNumber.getCurrencySymbol(this.saleCurrency);
        this.judicialFee = this.localeNumber.getJudicialFees({ start_at: this.startAt });
        this.voluntaryFee = this.localeNumber.getVoluntaryFees();
        this.vehiclesFeesWithoutTaxes = this.localeNumber.getVehiclesFees({
            currency: this.saleCurrency,
            start_at: this.startAt
        });
    }

    public getLiveOperator(): string {
        const operator = this.liveOperators.find(o => o?.id === this.liveSale?.operator_id);

        if (!operator) {
            return "";
        }

        return `
            ${operator?.first_name}
            ${operator?.last_name}
            ${
                operator?.phone
                    ? `- ${this.utils.formatPhoneNumber(operator.phone, {
                          v2Formatted: true
                      })}`
                    : ""
            }
        `;
    }

    public getLiveSubsEndingDate(): Date {
        return this.dateService.setDurationToDate(this.startAt, this.liveSale?.subscription_ending_interval);
    }
}
